"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateAccessRoleReassign = void 0;
const client_1 = require("@apollo/client");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const accessRoleReassignMutation = (0, client_1.gql) `
  mutation AccessRoleReassign($workspaceId: ID!, $roles: [RoleAssignInput!]!) {
    accessRoleReassign(workspace: $workspaceId, roles: $roles) {
      workspaceId
      permissions
      name
      isDefaultForNewUsers
      isDefaultAccessRoleManager
      isDefaultAccessRoleEmployee
      id
      assigns {
        userId
        created
      }
    }
  }`;
const mutateAccessRoleReassign = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(accessRoleReassignMutation, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.accessRoleReassign;
};
exports.mutateAccessRoleReassign = mutateAccessRoleReassign;
